<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="600px">
        <ul>
            <li v-for="item in detailMsg" :key="item.key">
                <span class="detail-label">{{ $t(item.text) }}：</span>
                <span class="detail-content">
                    <span v-if="item.key === 'param'">
                        {{ detailObj['behaviorParam'] ? JSON.parse(detailObj['behaviorParam']) : $t('integration.no_parameter_data') }}
                    </span>
                    <span v-else>
                        {{ $t(SwitchFn(item.key, detailObj[item.key], detailObj)) }}
                    </span>
                </span>
            </li>
        </ul>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['isShow', 'title', 'detailObj'],
    watch: {},
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShow;
            },
            set: function(val) {
                this.$emit('update:isShow', val); //可以优化成model  或者minx
            }
        }
    },
    data() {
        return {
            detailMsg: [
                {
                    key: 'fullPath',
                    text: 'public.belong'
                },
                {
                    key: 'event',
                    text: $t('public.event')
                },
                {
                    key: 'behavior',
                    text: $t('integration.behavior')
                },
                {
                    key: 'status',
                    text: $t('integration.state')
                },
                {
                    key: 'behaviorParam',
                    text: $t('public.content')
                },
                {
                    key: 'operator',
                    text: $t('integration.operator')
                },
                {
                    key: 'param',
                    text: $t('integration.data')
                }
            ],
            eventArray: [
                {
                    id: 1,
                    label: 'business.carrier_equipment',
                    children: [
                        {
                            id: 1,
                            // label: '取消-设备关联'
                            label: '新增安装点-关联设备'
                        },
                        {
                            id: 2,
                            // label: '监测点-关联'
                            label: '编辑安装点-关联设备'
                        },
                        {
                            id: 3,
                            // label: '设置-辅助'
                            label: '删除安装点-取消关联'
                        }
                    ]
                },
                {
                    id: 2,
                    label: $t('integration.abnormal_record'),
                    children: [
                        {
                            id: 1,
                            label: '处理-发生的异常'
                        },
                        {
                            id: 2,
                            label: '删除-发生的异常'
                        }
                    ]
                },
                {
                    id: 3,
                    label: 'business.record_point',
                    children: [
                        {
                            id: 1,
                            label: '设置-记录点'
                        },
                        {
                            id: 2,
                            label: '关闭-记录点'
                        }
                    ]
                },
                {
                    id: 4,
                    label: $t('integration.mount_information'),
                    children: [
                        {
                            id: 1,
                            label: $t('integration.newly_added')
                        },
                        {
                            id: 2,
                            label: $t('integration.to_update')
                        },
                        {
                            id: 3,
                            label: $t('public.tbopt_delete')
                        }
                    ]
                },
                {
                    id: 5,
                    label: $t('integration.alarm_settings'),
                    children: [
                        {
                            id: 1,
                            label: '启动-报警触发'
                        },
                        {
                            id: 2,
                            label: '撤销-报警触发'
                        }
                    ]
                }
            ],
            behaviorArray: [
                {
                    event: 1,
                    behavior: 1,
                    text: $t('integration.cancel_device')
                },
                {
                    event: 1,
                    behavior: 2,
                    text: 'business.carrier_equipment'
                },
                {
                    event: 1,
                    behavior: 3,
                    text: $t('integration.mount_auxiliary_settings')
                },
                {
                    event: 2,
                    behavior: 1,
                    text: $t('integration.handling_exceptions')
                },
                {
                    event: 2,
                    behavior: 2,
                    text: $t('integration.delete_exception')
                },
                {
                    event: 3,
                    behavior: 1,
                    text: $t('integration.set_recording_point')
                },
                {
                    event: 3,
                    behavior: 2,
                    text: $t('integration.close_record_point')
                },
                {
                    event: 4,
                    behavior: 1,
                    text: $t('business.add_carrier')
                },
                {
                    event: 4,
                    behavior: 2,
                    text: $t('integration.update_mount')
                },
                {
                    event: 4,
                    behavior: 3,
                    text: $t('integration.delete_mount')
                },
                {
                    event: 5,
                    behavior: 1,
                    text: $t('integration.set_alarm')
                },
                {
                    event: 5,
                    behavior: 2,
                    text: $t('device.alarm_off')
                }
            ]
        };
    },
    methods: {
        SwitchFn(key, value, row) {
            switch (key) {
                case 'event': {
                    return this.seventFn(value);
                }
                case 'behavior': {
                    return this.behaviorFn(row.event, value);
                }
                case 'status': {
                    return value === 1 ? this.$t('public.tip_oper_succ') : this.$t('public.tip_oper_fail');
                }
                case 'behaviorParam': {
                    return this.behaviorParamFn(row.event, row.behavior, value);
                }
                case 'param': {
                    return value || $t('integration.no_parameter_data');
                }
                default:
                    break;
            }
            return value;
        },
        seventFn(value) {
            let str = '';
            for (let item of this.eventArray) {
                if (item.id === value) {
                    str = item.label;
                    break;
                }
            }
            return str;
        },
        behaviorFn(eventId, value) {
            let str = '';
            this.behaviorArray.forEach(item => {
                if (eventId === item.event && value === item.behavior) {
                    str = item.text;
                }
            });
            return str;
        },
        behaviorParamFn(eventId, behaviorId, behaviorParam) {
            let str = '';
            let JsonContent = '';
            if (behaviorParam) {
                JsonContent = JSON.parse(behaviorParam);
            }
            this.eventArray.forEach(item => {
                if (item.id === eventId) {
                    item.children.forEach(opt => {
                        if (opt.id === behaviorId) {
                            let array = opt.label.split('-');
                            str = this.behavierTemplate(eventId, array, JsonContent, behaviorId);
                        }
                    });
                }
            });

            return str;
        },
        behavierTemplate(eventId, array, row, behaviorId) {
            let str = '';
            switch (eventId) {
                // 设备一对多
                case 1: {
                    // let newArray = row.map(item => {
                    //     return `[${item.name}(` + this.$t(`deviceType.${item.code}`) + ')]';
                    // });
                    // str = `${array[0]}` + newArray.join(',') + array[1];
                    str = `${array[0]}[${row.name}]${array[1]}[${row.device}]`;
                    break;
                }
                case 2: {
                    let newArray = row.map(item => {
                        return this.$timetransition(item.timestamp);
                    });
                    str = `${array[0]}` + newArray.join(',') + array[1];
                    break;
                }
                case 3: {
                    str = behaviorId === 1 ? $t('integration.set_recording_point') : $t('integration.close_record_point');
                    break;
                }
                case 4: {
                    str = `${array[0]}` + `[${row.name}-` + this.$t(`carrier.${row.typeId}`) + ']' + (array[1] ? array[1] : '');
                    break;
                }
                case 5: {
                    str = `${array[0]}[${row.map(item => item.name).join(',')}]${array[1]}`;
                    break;
                }
                default:
                    break;
            }

            return str;
        }
    }
};
</script>

<style lang="scss" scoped>
ul {
    li {
        line-height: 40px;
        display: flex;
        align-items: flex-start;

        .detail-label {
            text-align: right;
            white-space: nowrap;
            flex-shrink: 0;
        }

        .detail-content {
            text-align: left;
            flex: 1;
            word-break: break-all;
            padding-left: 8px;
        }
    }
}
</style>
